<div class="text-truncate">
  <ng-content />
</div>
@if (!hideClose()) {
  <span
    class="ms-2 btn btn-circle btn-sm btn-tertiary-ghost"
    aria-hidden="true"
    (click)="deletePill.emit()"
  >
    <si-icon [icon]="icons.elementCancel" />
  </span>
}
